import { RefObject, useLayoutEffect, useRef } from 'react';

function resolveScroller(element: HTMLElement | null): HTMLElement | null {
  if (!element) return null;
  const scrollsItself =
    element.scrollHeight > element.clientHeight &&
    getComputedStyle(element).overflowY !== 'visible';
  if (scrollsItself) return element;
  return (document.scrollingElement as HTMLElement | null) ?? null;
}

export default function usePreserveScrollOnPrepend(
  containerRef: RefObject<HTMLElement>,
  signature: string
): void {
  const renderedSignature = useRef(signature);
  const distanceFromBottom = useRef<number | null>(null);

  if (signature !== renderedSignature.current) {
    const scroller = resolveScroller(containerRef.current);
    distanceFromBottom.current =
      scroller && scroller.scrollTop > 0
        ? scroller.scrollHeight - scroller.scrollTop
        : null;
  }

  useLayoutEffect(() => {
    if (signature === renderedSignature.current) return;
    renderedSignature.current = signature;

    const distance = distanceFromBottom.current;
    distanceFromBottom.current = null;
    if (distance === null) return;

    const scroller = resolveScroller(containerRef.current);
    if (!scroller) return;
    scroller.scrollTop = scroller.scrollHeight - distance;
  }, [signature, containerRef]);
}
